import { useEffect, useState } from "react";
import { heroSlides } from "@/mocks/products";

export default function Hero() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % heroSlides.length);
    }, 5500);
    return () => clearInterval(timer);
  }, []);

  const goTo = (i: number) => setIndex(i);

  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden bg-secondary-200">
      {heroSlides.map((slide, i) => (
        <div
          key={slide.image}
          className={`absolute inset-0 transition-opacity duration-[1200ms] ease-out ${
            i === index ? "opacity-100" : "opacity-0"
          }`}
        >
          <img
            src={slide.image}
            alt={`Sofia Jewelry — ${slide.label}`}
            className="w-full h-full object-cover object-top animate-slow-zoom"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/45 via-foreground-950/10 to-transparent" />
        </div>
      ))}

      <div className="relative z-10 h-full w-full flex flex-col justify-end items-start px-6 md:px-16 pb-12 md:pb-16">
        <a
          href={heroSlides[index].href}
          className="animate-fade-up inline-block bg-background-50 text-foreground-950 hover:bg-primary-500 hover:text-foreground-950 font-label text-xs tracking-[0.28em] uppercase px-8 py-3.5 transition-colors rounded-md whitespace-nowrap"
        >
          {heroSlides[index].label}
        </a>
      </div>

      <div className="absolute bottom-5 left-1/2 -translate-x-1/2 z-10 flex items-center gap-2.5">
        {heroSlides.map((slide, i) => (
          <button
            key={slide.image}
            type="button"
            aria-label={`Go to slide ${i + 1}`}
            onClick={() => goTo(i)}
            className={`h-1.5 rounded-full transition-all duration-300 cursor-pointer ${
              i === index ? "w-7 bg-background-50" : "w-1.5 bg-background-50/50"
            }`}
          />
        ))}
      </div>
    </section>
  );
}